import React from 'react';

const Shipping = () => {
  return <div>Shipping Terms!</div>;
};

export default Shipping;
